import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"media/logos/logo_aragon.png\" class=\"logo-aragon\"><div style=\"width:100%;text-align:right;white-space:nowrap;\"><img src=\"media/logos/logo_iam.png\" class=\"logo-iam\"><img src=\"media/logos/logo_corresponsables.png\" class=\"logo-corresponsables\"></div><div class=\"d-flex align-items-center d-lg-none ms-n3 me-1\" title=\"Show aside menu\"><div class=\"btn btn-icon btn-active-light-primary\" id=\"kt_aside_mobile_toggle\"><i class=\"fas fa-bars ms-2 fs-2x mt-1\"></i></div></div>", 3)
const _hoisted_5 = { class: "d-flex align-items-stretch justify-content-end flex-lg-grow-1" }
const _hoisted_6 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}